import { styled } from '@mui/material/styles';
import { Typography } from '@mui/material';

export const TitleWithIcon = styled(Typography)`
  display: flex;
  align-items: center;
  column-gap: 1rem;
  justify-content: center;
`;
